<template>
  <AuthLayout :loading="form.processing">
    <template #logo>
      <div class="flex justify-end items-center pb-8 ">
        <AppLogo />
      </div>
    </template>

    <div class="max-w-md mx-auto p-6 bg-white rounded-xl shadow-md text-center mt-10">
      <h1 class="text-2xl font-bold text-red-600 mb-4">Verification Link Expired</h1>
      <p class="text-sm text-gray-600 mb-6">
        Please enter your email address to receive a new verification link.
      </p>

      <form @submit.prevent="resend">
        <JetInput id="email" v-model="form.email" type="email" class="block w-full mb-4 p-3 border rounded"
          placeholder="Your email" required autofocus />

        <JetButton :disabled="form.processing || timer > 0"
          :class="{ 'opacity-25 cursor-not-allowed': form.processing || timer > 0 }" class="w-full justify-center">
          Resend verification email
        </JetButton>

        <p v-if="timer > 0" class="text-xs text-gray-500 mt-2">
          You can resend again in <span class="font-semibold">{{ formattedTime }}</span>
        </p>
      </form>

      <div v-if="form.errors.email" class="text-red-500 text-sm mt-2">
        {{ form.errors.email }}
      </div>

      <div v-if="status" class="text-green-600 text-sm mt-4">
        {{ status }}
      </div>
    </div>
  </AuthLayout>
</template>

<script>

import AuthLayout from '@/Layouts/AuthLayout.vue'
import AppLogo from '@/Components/AppLogo.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'

export default {

  components: {
    AuthLayout,
    AppLogo,
    JetButton,
    JetInput,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: ''
      }),
      timer: 0,
      countdownInterval: null,
    }
  },

  computed: {
    formattedTime() {
      const minutes = Math.floor(this.timer / 60).toString().padStart(2, '0')
      const seconds = (this.timer % 60).toString().padStart(2, '0')
      return `${minutes}:${seconds}`
    },
  },

  methods: {
    resend() {
      this.form.post(this.route('email.public-resend'), {
        preserveScroll: true,
        onSuccess: () => {
          const unlockTime = Math.floor(Date.now() / 1000) + 600 // 10 minutes
          localStorage.setItem('resendUnlockTime', unlockTime)
          this.setTimer()
          this.startCountdown()
          this.$inertia.visit('/email/verify', { replace: true })
        }
      })
    },

    setTimer() {
      const now = Math.floor(Date.now() / 1000)
      const unlockTime = parseInt(localStorage.getItem('resendUnlockTime') || '0', 10)
      this.timer = Math.max(unlockTime - now, 0)
    },

    startCountdown() {
      if (this.countdownInterval) clearInterval(this.countdownInterval)

      this.countdownInterval = setInterval(() => {
        this.setTimer()
        if (this.timer <= 0) {
          clearInterval(this.countdownInterval)
          this.countdownInterval = null
        }
      }, 1000)
    },
  },

  mounted() {
    this.setTimer()
    if (this.timer > 0) {
      this.startCountdown()
    }
  },

  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  },
}
</script>